import React from 'react';
import { Button } from '../ui/Button';
import { CheckCircle2, ShieldCheck, CreditCard, ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';
export function Hero() {
  return <section className="relative overflow-hidden bg-slate-900 pt-16 pb-12 md:pt-32 md:pb-24 text-white" data-id="element-115">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-10 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-teal-400 via-slate-900 to-slate-900" data-id="element-116"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-117">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="max-w-3xl mx-auto text-center" data-id="element-118">
          <div className="inline-flex gap-2 px-3 py-1.5 rounded-full bg-teal-500/20 text-teal-300 text-xs md:text-sm font-semibold mb-4 md:mb-6 border border-teal-500/30 items-center justify-center" data-id="element-119">
            <span className="flex h-2 w-2 rounded-full bg-teal-400" data-id="element-120"></span>
            Para Oncólogos Independientes
          </div>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-extrabold tracking-tight mb-6 md:mb-8 leading-tight" data-id="element-121">
            IMPLEMENTÁ EL SISTEMA COMPLETO DE GESTIÓN DE TU{' '}
            <span className="text-teal-400" data-id="element-122">
              CONSULTORIO ONCOLÓGICO EN 7 DÍAS
            </span>
          </h1>

          {/* Mockup principal — al 70% de su tamaño, entre título y subtítulo */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.92
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="relative mb-6 md:mb-8" data-id="element-123">
            <div className="absolute inset-0 bg-gradient-to-tr from-teal-500/20 to-amber-500/20 rounded-3xl blur-3xl" data-id="element-124"></div>
            <motion.img whileHover={{
            scale: 1.02
          }} transition={{
            duration: 0.3
          }} src="https://cdn.magicpatterns.com/uploads/teLSGh4uq6698nQ2eb4oy1/MOCKUP_TRANSPARENTE_ONCOLOGO.png" alt="Megapack de Gestión para Consultorio Oncológico - Mockup del producto" className="relative z-10 w-[70%] mx-auto h-auto drop-shadow-2xl" loading="eager" fetchPriority="high" decoding="async" width={1024} height={1024} data-id="element-125" />
          </motion.div>

          <p className="text-lg md:text-xl text-slate-300 mb-6 md:mb-8 leading-relaxed" data-id="element-126">
            Seguimiento de pacientes, autorizaciones, facturación e indicadores.
            Sin desorden, sin improvisar.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 mb-6 md:mb-8 justify-center" data-id="element-127">
            <Button variant="secondary" size="lg" href="#pricing" className="group" data-id="element-128">
              💼 QUIERO MI MEGAPACK AHORA
              <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" data-id="element-129" />
            </Button>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6 text-xs md:text-sm text-slate-400" data-id="element-130">
            <div className="flex items-center gap-1.5 md:gap-2" data-id="element-131">
              <ShieldCheck className="h-4 w-4 md:h-5 md:w-5 text-teal-400" data-id="element-132" />
              <span data-id="element-133">Garantía 7 días</span>
            </div>
            <div className="flex items-center gap-1.5 md:gap-2" data-id="element-134">
              <CreditCard className="h-4 w-4 md:h-5 md:w-5 text-teal-400" data-id="element-135" />
              <span data-id="element-136">Pago seguro Mercado Pago</span>
            </div>
            <div className="flex items-center gap-1.5 md:gap-2" data-id="element-137">
              <CheckCircle2 className="h-4 w-4 md:h-5 md:w-5 text-teal-400" data-id="element-138" />
              <span data-id="element-139">Acceso Inmediato</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}